import React, { useState } from 'react';

interface LazyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: React.ReactNode;
}

const LazyImage = ({ 
  src,
  alt,
  className,
  fallback,
  ...props
}: LazyImageProps): React.ReactElement | null => {
  const [imageLoaded, setImageLoaded] = useState(false);

  if (!src) {
    return fallback as React.ReactElement || null;
  }

  return (
    <div className="image-container loading">
      <div className="image-placeholder" />
      <img 
        src={src}
        alt={alt}
        className={`${className || ''} ${imageLoaded ? 'loaded' : ''}`}
        loading="lazy"
        decoding="async"
        onLoad={() => setImageLoaded(true)}
        {...props}
      />
    </div>
  );
};

export default LazyImage;
